// extracted by mini-css-extract-plugin
module.exports = {"VideoReport":"styles_VideoReport__1ZtCc","pagination":"styles_pagination__1b05p"};